import type { StudentStatus } from "../../api/students";
import { STUDENT_STATUS_LABELS } from "../students/StudentStatusSelect";

export type StudentListStatusFilter = StudentStatus | "";

export const DEFAULT_STUDENT_LIST_STATUS_FILTER: StudentListStatusFilter = "active";

const FILTER_OPTIONS: StudentStatus[] = ["active", "passive", "graduated"];

type Props = {
  value: StudentListStatusFilter;
  onChange: (value: StudentListStatusFilter) => void;
  className?: string;
  disabled?: boolean;
  allLabel?: string;
};

export function StudentListStatusFilterSelect({
  value,
  onChange,
  className = "kp-input",
  disabled,
  allLabel = "Tüm durumlar",
}: Props) {
  return (
    <select
      className={className}
      value={value}
      disabled={disabled}
      aria-label="Kursiyer durum filtresi"
      onChange={(e) => onChange(e.target.value as StudentListStatusFilter)}
    >
      <option value="">{allLabel}</option>
      {FILTER_OPTIONS.map((status) => (
        <option key={status} value={status}>
          {STUDENT_STATUS_LABELS[status]}
        </option>
      ))}
    </select>
  );
}
